import { CachedBulkFetchService } from '@/services/bulkFetch/abstractBulkFetch.service';
import httpService from '@/services/http/http.service';
import { MapRequest, WoWMap, WoWZone, ZoneRequest, WoWMapViewModel, WoWZoneViewModel } from '@/types/apiServerContract';
import KeyBy from 'lodash-es/keyBy';

class WoWMapService extends CachedBulkFetchService<WoWMap> {
    constructor(protected controller: string) {
        super(controller);
    }

    protected async apiCall(ids: number[]): Promise<{ [key: number]: WoWMap }> {
        const request: MapRequest = {
            mapIds: ids
        };
        const result = await httpService.Post<WoWMapViewModel>(this.getUrl('GetMaps'), request);
        return KeyBy<WoWMap>(result.maps, 'id');
    }

    public async getMapName(id: number): Promise<string> {
        const item = await this.getCachedItem(id);
        return item.name;
    }
}

class WoWZoneService extends CachedBulkFetchService<WoWZone> {
    constructor(protected controller: string) {
        super(controller);
    }

    protected async apiCall(ids: number[]): Promise<{ [key: number]: WoWZone }> {
        const request: ZoneRequest = {
            zoneIds: ids
        };
        const result = await httpService.Post<WoWZoneViewModel>(this.getUrl('GetZones'), request);
        return KeyBy<WoWZone>(result.zones, 'id');
    }

    public async getZoneName(id: number): Promise<string> {
        const item = await this.getCachedItem(id);
        return item.name;
    }
}

export default class GameService {
	public static mapService = new WoWMapService('game');
	public static zoneSerice = new WoWZoneService('game');
}
